import { graphql } from '../../../gql'

// connected to websocket
export const updatePropertyAnswerMutation = graphql(`
  mutation UpdatePropertyAnswer($input: UpdatePropertyAnswerInput!) {
    updatePropertyAnswer(input: $input) {
      id
      value
    }
  }
`)

// connected to websocket
export const updateMultiplePropertyAnswersMutation = graphql(`
  mutation UpdateMultiplePropertyAnswers($input: [UpdatePropertyAnswerInput]!) {
    updateMultiplePropertyAnswers(input: $input) {
      id
      answers {
        id
        value
      }
      emptyRequiredFields {
        id
        title
      }
      emptyRequiredNotificationFields
    }
  }
`)

// connected to websocket
export const addUserToGroupMutation = graphql(`
  mutation AddUserToGroup($input: AddUserToGroupInput!) {
    addUserToGroup(input: $input) {
      ...oneGroupDetails
    }
  }
`)

// connected to websocket
export const addMembershipMutation = graphql(`
  mutation AddMembership($input: AddMembershipInput!) {
    addMembership(input: $input) {
      id
      memberships {
        ...allMembershipDetails
      }
    }
  }
`)

// connected to websocket
export const updateUserMutation = graphql(`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      ...userDetails
    }
  }
`)

// connected to websocket
export const updateUserWithMultiplePropertiesMutation = graphql(`
  mutation UpdateUserWithMultipleProperties($input: UpdateUserWithMultiplePropertiesInput!) {
  updateUserWithMultipleProperties(input: $input) {
      id
      ...userDetails
    }
  }
`)

// connected to websocket
export const updateMembershipStatusMutation = graphql(`
  mutation UpdateMembershipStatus($input: UpdateMembershipStatusInput!) {
    updateMembershipStatus(input: $input) {
      id
      memberships {
        id
        status
      }
    }
  }
`)

export const loginUserMutation = graphql(`
  mutation LoginUser($input: LoginUserInput!) {
    loginUser(input: $input) {
      id
      access_token
      refresh_token
      expiry
    }
  }
`)

export const refreshTokenMutation = graphql(`
  mutation RefreshToken($refresh_token: String!) {
    refreshToken(refresh_token: $refresh_token) {
      id
      access_token
      refresh_token
      expiry
    }
  }
`)

export const logoutUserMutation = graphql(`
  mutation LogoutUser {
    logoutUser
  }
`)

export const addScheduleSlotToRoleMutation = graphql(`
  mutation AddScheduleSlotToRole($input: AddScheduleSlotToRoleInput!) {
    addScheduleSlotToRole(input: $input) {
      id
      begin
      end
    }
  }
`)

export const removeScheduleSlotFromRoleMutation = graphql(`
  mutation RemoveScheduleSlotFromRole($input: RemoveScheduleSlotFromRoleInput!) {
    removeScheduleSlotFromRole(input: $input) {
      ...sectionSlot
      begin
      end
      sectionRole {
        id
        userAvailabilities {
          id
          firstName
          surname
          acceptedSlots {
            id
            begin
            end
          }
          availabilitySlots {
            id
            begin
            end
          }
        }
      }
    }
  }
`)

export const convertScheduleSlotToLeadMutation = graphql(`
  mutation ConvertScheduleSlotToLead($input: ConvertScheduleSlotToLeadInput!) {
    convertScheduleSlotToLead(input: $input) {
      ...sectionSlotLead
      begin
      end
      note
      sectionRole {
        id
        section {
          id
        }
      }
    }
  }
`)

export const convertScheduleSlotLeadToSlotMutation = graphql(`
  mutation ConvertScheduleSlotLeadToSlot($input: ConvertScheduleSlotLeadToSlotInput!) {
    convertScheduleSlotLeadToSlot(input: $input) {
      ...sectionSlot
      begin
      end
      note
      useAsTemplate
      autoConfirm
      isPrivate
      queueActive
      isFlexSlot
      deleteOnReject
      checkinTime
    }
  }
`)

export const removeScheduleSlotLeadFromRoleMutation = graphql(`
  mutation RemoveScheduleSlotLeadFromRole($input: RemoveScheduleSlotLeadFromRoleInput!) {
    removeScheduleSlotLeadFromRole(input: $input) {
      id
    }
  }
`)

export const addLeadScheduleSlotToRoleMutation = graphql(`
  mutation AddScheduleSlotLeadToRole($input: AddScheduleSlotLeadToRoleInput!) {
    addScheduleSlotLeadToRole(input: $input) {
      id
      begin
      end
      sectionRole {
        id
        section {
          id
        }
      }
    }
  }
`)

export const updateScheduleSlotMutation = graphql(`
  mutation UpdateScheduleSlot($input: UpdateScheduleSlotInput!) {
    updateScheduleSlot(input: $input) {
      id
      begin
      end
      note
      useAsTemplate
      autoConfirm
      deleteOnReject
      isPrivate
      queueActive
      isFlexSlot
    }
  }
`)

export const updateLeadScheduleSlotMutation = graphql(`
  mutation UpdateLeadScheduleSlot($input: UpdateLeadScheduleSlotInput!) {
    updateLeadScheduleSlot(input: $input) {
      id
      begin
      end
      note
      acceptedUser {
        id
        firstName
        surname
      }
    }
  }
`)

export const addUserNoteMutation = graphql(`
  mutation AddUserNote($input: AddUserNoteInput!) {
    addUserNote(input: $input) {
      id
      created
      author {
        id
        firstName
        surname
      }
      message
    }
  }
`)

export const createWarehouseMutation = graphql(`
  mutation CreateWarehouse($input: CreateWarehouseInput!) {
    createWarehouse(input: $input) {
      id
      title
      description
      imageUrl
      storagePlaces {
        id
      }
    }
  }
`)

export const updateWarehouseMutation = graphql(`
  mutation UpdateWarehouse($input: UpdateWarehouseInput!) {
    updateWarehouse(input: $input) {
      id
      title
      description
      imageUrl
      storagePlaces {
        id
      }
    }
  }
`)

export const createStoragePlaceMutation = graphql(`
  mutation CreateStoragePlace($input: CreateStoragePlaceInput!) {
    createStoragePlace(input: $input) {
      id
      title
      description
      imageUrl
      itemInventories {
        id
      }
    }
  }
`)

export const updateStoragePlaceMutation = graphql(`
  mutation UpdateStoragePlace($input: UpdateStoragePlaceInput!) {
    updateStoragePlace(input: $input) {
      id
      title
      description
      imageUrl
      itemInventories {
        id
      }
    }
  }
`)

export const createArticleTemplateMutation = graphql(`
  mutation CreateArticleTemplate($input: CreateArticleTemplateInput!) {
    createArticleTemplate(input: $input) {
      id
      title
      description
      imageUrl
    }
  }
`)

export const updateArticleTemplateMutation = graphql(`
  mutation UpdateArticleTemplate($input: UpdateArticleTemplateInput!) {
    updateArticleTemplate(input: $input) {
      id
      title
      description
      imageUrl
    }
  }
`)

export const createItemInventoryMutation = graphql(`
  mutation CreateItemInventory($input: CreateItemInventoryInput!) {
    createItemInventory(input: $input) {
      id
      title
      description
      amount
      imageUrl
      articleTemplate {
        id
        title
      }
    }
  }
`)

export const updateItemInventoryMutation = graphql(`
  mutation UpdateItemInventory($input: UpdateItemInventoryInput!) {
    updateItemInventory(input: $input) {
      id
      title
      description
      amount
      imageUrl
      articleTemplate {
        id
        title
      }
    }
  }
`)

// connected to websocket (membership)
export const changeStatusLabelForMembershipMutation = graphql(`
  mutation ChangeStatusLabelForMembership($input: ChangeStatusLabelForMembershipInput!) {
    changeStatusLabelForMembership(input: $input) {
      id
      statusLabels {
        id
        title
        color
      }
    }
  }
`)

// connected to websocket (user)
export const updateProfileImageMutation = graphql(`
  mutation UpdateProfileImage($input: UpdateProfileImageInput!) {
    updateProfileImage(input: $input) {
      id
      profileImageUrl
    }
  }
`)

// connected to websocket (user)
export const addSectionRoleToCurrentSeasonMutation = graphql(`
  mutation AddSectionRoleToCurrentSeason($input: AddSectionRoleToCurrentSeasonInput!) {
    addSectionRoleToCurrentSeason(input: $input) {
      id
      sectionRoles {
        id
        title
        season
      }
    }
  }
`)

// connected to websocket (user)
export const addSectionToCurrentSeasonMutation = graphql(`
  mutation AddSectionToCurrentSeason($input: AddSectionToCurrentSeasonInput!) {
    addSectionToCurrentSeason(input: $input) {
      id
      sections {
        id
        title
        season
      }
      sectionRoles {
        id
        title
        season
      }
    }
  }
`)

// connected to websocket (user)
export const addSectionLeadToCurrentSeasonMutation = graphql(`
  mutation AddSectionLeadToCurrentSeason($input: AddSectionLeadToCurrentSeasonInput!) {
    addSectionLeadToCurrentSeason(input: $input) {
      id
      sectionLeads {
        id
        title
        season
      }
      sections {
        id
        title
        season
      }
      sectionRoles {
        id
        title
        season
      }
    }
  }
`)

export const updateStatusLabelMutation = graphql(`
  mutation UpdateStatusLabel($input: UpdateStatusLabelInput!) {
    updateStatusLabel(input: $input) {
      id
      title
      color
    }
  }
`)

export const createStatusLabelForGroupMutation = graphql(`
  mutation CreateStatusLabelForGroup($input: CreateStatusLabelForGroupInput!) {
    createStatusLabelForGroup(input: $input) {
      id
      title
      color
    }
  }
`)

export const deleteStatusLabelMutation = graphql(`
  mutation DeleteStatusLabel($input: DeleteStatusLabelInput!) {
    deleteStatusLabel(input: $input) {
      id
    }
  }
`)

export const resendRegistrationEmailMutation = graphql(`
  mutation ResendRegistrationEmail($input: ResendRegistrationEmailInput!) {
    resendRegistrationEmail(input: $input) {
      id
    }
  }
`)

export const resendCheckinMailMutation = graphql(`
  mutation ResendCheckinMail($input: ResendCheckinMailInput!) {
    resendCheckinMail(input: $input)
  }
`)

export const sendScheduleChangeEmailMutation = graphql(`
  mutation SendScheduleChangeEmail($input: SendScheduleChangeEmailInput!) {
    sendScheduleChangeEmail(input: $input) {
      id
      scheduleEmailStatus
    }
  }
`)

export const sendScheduleEmailMutation = graphql(`
  mutation SendScheduleEmail($input: SendScheduleChangeEmailInput!) {
    sendScheduleEmail(input: $input) {
      id
      scheduleEmailStatus
    }
  }
`)

export const resetScheduleEmailStatusToCheckinMutation = graphql(`
  mutation ResetScheduleEmailStatusToCheckin($input: ResetScheduleEmailStatusInput!) {
    resetScheduleEmailStatusToCheckin(input: $input) {
      id
      scheduleEmailStatus
    }
  }
`)

// connected to websocket
export const updateCheckinTimeForUserMutatioon = graphql(`
  mutation UpdateCheckinTimeForUser($input: UpdateCheckinTimeForUserInput!) {
    updateCheckinTimeForUser(input: $input) {
      id
      currentSeasonCheckin {
        id
        arrivalDate
        arrivalTime
        departureDate
        departureTime
      }
    }
  }
`)

export const addAvailabilitySlotMutation = graphql(`
  mutation AddAvailabilitySlot($input: AddAvailabilitySlotInput!) {
    addAvailabilitySlot(input: $input) {
      id
      availabilitySlots {
        id
        begin
        end
      }
    }
  }
`)

export const removeAvailabilitySlotMutation = graphql(`
  mutation RemoveAvailabilitySlot($input: RemoveAvailabilitySlotInput!) {
    removeAvailabilitySlot(input: $input) {
      id
      availabilitySlots {
        id
        begin
        end
      }
    }
  }
`)

export const acceptUserForSectionSlotMutation = graphql(`
  mutation AcceptUserForSectionSlot($input: AcceptUserForSectionSlotInput!) {
    acceptUserForSectionSlot(input: $input) {
      id
      acceptedSlots {
        id
        begin
        end
        acceptedUser {
          id
        }
      }
    }
  }
`)

export const acceptUserForSectionSlotAndDuplicateMutation = graphql(`
  mutation AcceptUserForSectionSlotAndDuplicate($input: AcceptUserForSectionSlotAndDuplicateInput!) {
    acceptUserForSectionSlotAndDuplicate(input: $input) {
      id
      acceptedUser {
        id
        acceptedSlots {
          id
        }
      }
      begin
      end
      note
      useAsTemplate
      autoConfirm
      isPrivate
      queueActive
      isFlexSlot
      sectionRole {
        id
      }
    }
  }
`)

export const rejectUserForSectionSlotMutation = graphql(`
  mutation RejectUserForSectionSlot($input: RejectUserForSectionSlotInput!) {
    rejectUserForSectionSlot(input: $input) {
      id
      rejectedUsers {
        id
      }
    }
  }
`)

export const unrejectUserForSectionSlotMutation = graphql(`
  mutation UnrejectUserForSectionSlot($input: UnrejectUserForSectionSlotInput!) {
    unrejectUserForSectionSlot(input: $input) {
      id
      rejectedUsers {
        id
      }
    }
  }
`)

export const acceptAllUserForSlotAndDuplicateMutation = graphql(`
  mutation AcceptAllUserForSlotAndDuplicate($input: AcceptAndDuplicateAllUserForSlotInput!) {
    acceptAndDuplicateAllUserForSlot(input: $input) {
      id
      acceptedSlots {
        id
        acceptedUser {
          id
        }
      }
    }
  }
`)

export const dropUserForSectionSlotMutation = graphql(`
  mutation DropUserForSectionSlot($input: DropUserForSectionSlotInput!) {
    dropUserForSectionSlot(input: $input) {
      id
      acceptedSlots {
        id
      }
    }
  }
`)

export const transferUserForSectionSlotMutation = graphql(`
  mutation TransferUserForSectionSlot($input: TransferUserForSectionSlotInput!) {
    transferUserForSectionSlot(input: $input) {
      ...sectionSlot
      begin
      end
      sectionRole {
        id
      }
    }
  }
`)

export const updateAvailabilitySlotMutation = graphql(`
  mutation UpdateAvailabilitySlot($input: UpdateAvailabilitySlotInput!) {
    updateAvailabilitySlot(input: $input) {
      id
      availabilitySlots {
        id
        begin
        end
      }
    }
  }
`)

export const deleteAvailabilitySlotMutation = graphql(`
  mutation DeleteAvailabilitySlot($id: ID!) {
    deleteAvailabilitySlot(id: $id) {
      id
      availabilitySlots {
        id
        begin
        end
      }
    }
  }
`)

export const updateSectionLeadMutation = graphql(`
  mutation UpdateSectionLeader($input: UpdateSectionLeaderInput!) {
    updateSectionLeader(input: $input) {
      id
      sectionLeaders {
        id
        firstName
        surname
        phone
        email
        profileImageUrl
      }
    }
  }
`)

export const createGuestListItemMutation = graphql(`
  mutation CreateGuestListItem($input: CreateGuestListItemInput!) {
    createGuestListItem(input: $input) {
      ...guestListItemDetails
    }
  }
`)

export const updateGuestListItemMutation = graphql(`
  mutation UpdateGuestListItem($input: UpdateGuestListItemInput!) {
    updateGuestListItem(input: $input) {
      ...guestListItemDetails
    }
  }
`)

export const deleteGuestListItemMutation = graphql(`
  mutation DeleteGuestListItem($input: DeleteGuestListItemInput!) {
    deleteGuestListItem(input: $input) {
      ...guestListItemDetails
    }
  }
`)

export const createSeasonCheckinItemMutation = graphql(`
  mutation CreateSeasonCheckinItem($input: CreateSeasonCheckinItemInput!) {
    createSeasonCheckinItem(input: $input) {
      id
      title
      type
      quantity
      property {
        id
        title
      }
      propertyOptionQuantities {
        id
        quantity
        propertyOption {
          id
          title
        }
      }
    }
  }
`)

export const updateSeasonCheckinItemMutation = graphql(`
  mutation UpdateSeasonCheckinItem($input: UpdateSeasonCheckinItemInput!) {
    updateSeasonCheckinItem(input: $input) {
      id
      title
      type
      quantity
      property {
        id
        title
      }
      propertyOptionQuantities {
        id
        quantity
        propertyOption {
          id
          title
        }
      }
    }
  }
`)

export const deleteSeasonCheckinItemMutation = graphql(`
  mutation DeleteSeasonCheckinItem($input: DeleteSeasonCheckinItemInput!) {
    deleteSeasonCheckinItem(input: $input) {
      id
      title
      type
    }
  }
`)

export const createSeasonCheckinItemGenericIssueMutation = graphql(`
  mutation CreateSeasonCheckinItemGenericIssue($input: CreateSeasonCheckinItemGenericIssueInput!) {
    createSeasonCheckinItemGenericIssue(input: $input) {
      id
      seasonCheckinItems {
        id
        quantity
        issuedAmount
        remainingAmount
        propertyOptionQuantities {
          id
          quantity
          issuedAmount
          requestedAmount
        }
      }
      seasonCheckinItemGenericIssues {
        id
        title
        quantity
        created
        seasonCheckinItem {
          id
          title
        }
        seasonCheckinItemPropertyOptionQuantity {
          id
          propertyOption {
            id
            title
          }
        }
      }
    }
  }
`)

export const updateSeasonCheckinItemGenericIssueMutation = graphql(`
  mutation UpdateSeasonCheckinItemGenericIssue($input: UpdateSeasonCheckinItemGenericIssueInput!) {
    updateSeasonCheckinItemGenericIssue(input: $input) {
      id
      seasonCheckinItems {
        id
        quantity
        issuedAmount
        remainingAmount
        propertyOptionQuantities {
          id
          quantity
          issuedAmount
          requestedAmount
        }
      }
      seasonCheckinItemGenericIssues {
        id
        title
        quantity
        created
        seasonCheckinItem { id title }
        seasonCheckinItemPropertyOptionQuantity { id propertyOption { id title } }
      }
    }
  }
`)

export const deleteSeasonCheckinItemGenericIssueMutation = graphql(`
  mutation DeleteSeasonCheckinItemGenericIssue($input: DeleteSeasonCheckinItemGenericIssueInput!) {
    deleteSeasonCheckinItemGenericIssue(input: $input) {
      id
      seasonCheckinItems {
        id
        quantity
        issuedAmount
        remainingAmount
        propertyOptionQuantities {
          id
          quantity
          issuedAmount
          requestedAmount
        }
      }
      seasonCheckinItemGenericIssues {
        id
        title
        quantity
        created
        seasonCheckinItem { id title }
        seasonCheckinItemPropertyOptionQuantity { id propertyOption { id title } }
      }
    }
  }
`)

export const createSeasonCheckinItemPropertyOptionQuantityMutation = graphql(`
  mutation CreateSeasonCheckinItemPropertyOptionQuantity($input: CreateSeasonCheckinItemPropertyOptionQuantityInput!) {
    createSeasonCheckinItemPropertyOptionQuantity(input: $input) {
      id
      quantity
      propertyOption {
        id
        title
      }
    }
  }
`)

export const updateSeasonCheckinItemPropertyOptionQuantityMutation = graphql(`
  mutation UpdateSeasonCheckinItemPropertyOptionQuantity($input: UpdateSeasonCheckinItemPropertyOptionQuantityInput!) {
    updateSeasonCheckinItemPropertyOptionQuantity(input: $input) {
      id
      quantity
      propertyOption {
        id
        title
      }
    }
  }
`)

export const deleteSeasonCheckinItemPropertyOptionQuantityMutation = graphql(`
  mutation DeleteSeasonCheckinItemPropertyOptionQuantity($input: DeleteSeasonCheckinItemPropertyOptionQuantityInput!) {
    deleteSeasonCheckinItemPropertyOptionQuantity(input: $input) {
      id
      quantity
      propertyOption {
        id
        title
      }
    }
  }
`)

export const checkinGuestListItemMutation = graphql(`
  mutation CheckinGuestList($input: CheckinGuestListInput!) {
    checkinGuestList(input: $input) {
      id
      checkinTime
      guestListItemCheckins {
          id
          checkinTime
      }
    }
  }
`)

export const checkinUserMutation = graphql(`
  mutation CheckinUser($input: CheckinUserInput!) {
    checkinUser(input: $input) {
      id
      checkinTime
      seasonCheckinItems {
        id
        title
        checkinTime
      }
    }
  }
`)

export const checkoutUserMutation = graphql(`
  mutation CheckoutUser($input: CheckoutUserInput!) {
    checkoutUser(input: $input) {
      id
      begin
      end
      checkoutTime
      sectionRole {
        id
        title
      }
    }
  }
`)

export const changeMessagePropertyMutation = graphql(`
  mutation ChangeMessageProperty($input: ChangeMessagePropertyInput!) {
    changeMessageProperty(input: $input) {
      id
      title
      subject
      summary
      content
      recipientType
      onlyConfirmedMembers
      notificationPermission
      recipientAmount
      finalized
      userGroups {
        id
        title
      }
      userRecipients {
        id
        firstName
        surname
      }
    }
  }
`)

export const sendMessageMutation = graphql(`
  mutation SendMessage($messageID: String!) {
    sendMessage(messageID: $messageID) {
      id
      title
      subject
      summary
      content
      recipientType
      onlyConfirmedMembers
      notificationPermission
      recipientAmount
      finalized
      userGroups {
        id
        title
      }
      userRecipients {
        id
        firstName
        surname
      }
    }
  }
`)

export const addMessageMutation = graphql(`
  mutation AddMessage {
    addMessage {
      id
      title
      subject
      summary
      content
      finalized
    }
  }
`)

export const deleteMessageMutation = graphql(`
  mutation DeleteMessage($messageID: String!) {
    deleteMessage(messageID: $messageID) {
      id
      title
      subject
      summary
      content
      finalized
    }
  }
`)

export const confirmScheduleAgreementMutation = graphql(`
  mutation ConfirmScheduleAgreement {
    confirmScheduleAgreement {
      id
      currentSeasonCheckin {
        id
        acceptScheduleAgreement
      }
    }
  }
`)

export const cancelScheduleSlotMutation = graphql(`
  mutation CancelScheduleSlot($input: CancelScheduleSlotInput!) {
    cancelScheduleSlot(input: $input) {
      id
      acceptedSlots {
        id
      }
    }
  }
`)

export const splitScheduleSlotMutations = graphql(`
  mutation SplitScheduleSlot($input: SplitScheduleSlotInput!) {
    splitScheduleSlot(input: $input) {
      ...sectionSlot
      begin
      end
      note
      useAsTemplate
      autoConfirm
      isPrivate
      queueActive
      isFlexSlot
    }
  }
`)

export const duplicateScheduleSlotMutations = graphql(`
  mutation DuplicateScheduleSlot($input: DuplicateScheduleSlotInput!) {
    duplicateScheduleSlot(input: $input) {
      ...sectionSlot
      begin
      end
      note
      useAsTemplate
      autoConfirm
      isPrivate
      queueActive
      isFlexSlot
    }
  }
`)

export const addPassMutation = graphql(`
  mutation AddPass($input: AddPassInput!) {
    addPass(input: $input) {
      id
      passID
      type
      organisation
      userType
      user {
        id
        firstName
        surname
      }
      firstName
      surname
      checkinTime
    }
  }
`)

export const updatePassMutation = graphql(`
  mutation UpdatePass($input: UpdatePassInput!) {
    updatePass(input: $input) {
      id
      passID
      type
      organisation
      userType
      user {
        id
        firstName
        surname
      }
      firstName
      surname
      checkinTime
    }
  }
`)

export const deletePassMutation = graphql(`
  mutation DeletePass($input: DeletePassInput!) {
    deletePass(input: $input) {
      id
    }
  }
`)

export const checkinPassMutation = graphql(`
  mutation CheckinPass($input: CheckinPassInput!) {
    checkinPass(input: $input) {
      id
      passID
      checkinTime
    }
  }
`)

export const preparePassMutation = graphql(`
  mutation PreparePass($input: PreparePassInput!) {
    preparePass(input: $input) {
      id
      passID
      prepareTime
      checkinTime
    }
  }
`)

export const checkinSlotMutation = graphql(`
  mutation CheckinSectionSlot($input: CheckinSectionSlotInput!) {
    checkinSectionSlot(input: $input) {
      id
      checkinTime
    }
  }
`)

export const addWebPushSubscriptionMutation = graphql(`
  mutation AddWebPushSubscription($input: AddWebPushSubscriptionInput!) {
    addWebPushSubscription(input: $input)
  }
`)

export const updateSectionRoleMutation = graphql(`
  mutation UpdateSectionRole($input: UpdateSectionRoleInput!) {
    updateSectionRole(input: $input) {
      id
      title
      description
    }
  }
`)

export const createSectionRoleGroupMutation = graphql(`
  mutation CreateSectionRoleGroup($input: CreateSectionRoleGroupInput!) {
    createSectionRoleGroup(input: $input) {
      id
      title
      sectionRoles {
        id
        title
      }
    }
  }
`)

export const updateSectionRoleGroupMutation = graphql(`
  mutation UpdateSectionRoleGroup($input: UpdateSectionRoleGroupInput!) {
    updateSectionRoleGroup(input: $input) {
      id
      title
      sectionRoles {
        id
        title
      }
    }
  }
`)

export const deleteSectionRoleGroupMutation = graphql(`
  mutation DeleteSectionRoleGroup($input: DeleteSectionRoleGroupInput!) {
    deleteSectionRoleGroup(input: $input) {
      id
      title
      sectionRoles {
        id
        title
      }
    }
  }
`)

export const addSeasonNoticeForUserMutation = graphql(`
  mutation AddSeasonNoticeForUser($input: AddSeasonNoticeForUserInput!) {
    addSeasonNoticeForUser(input: $input) {
      id
      seasonNotice
    }
  }
`)

export const selfCheckinSectionSlotMutation = graphql(`
  mutation SelfCheckinSectionSlot($input: SelfCheckinSectionSlotInput!) {
    selfCheckinSectionSlot(input: $input) {
      id
      acceptedSlots {
        id
        checkinTime
      }
    }
  }
`)

export const addCateringMealDistributionMutation = graphql(`
    mutation AddCateringMealDistribution($input: AddCateringMealDistributionInput!) {
        addCateringMealDistribution(input: $input) {
            id
            cateringMealDistributions {
                id
                timestamp
                terminalID
                userID
                userName
                isAdditionalMeal
            }
        }
    }
`)

export const syncCateringMealDistributionMutation = graphql(`
    mutation SyncCateringMealDistribution($input: SyncCateringMealDistributionInput!) {
        syncCateringMealDistribution(input: $input) {
            id
            cateringMealDistributions {
                id
                timestamp
                terminalID
                userID
                userName
                isAdditionalMeal
            }
        }
    }
`)

export const addReceiptMutation = graphql(`
    mutation AddReceipt($input: AddReceiptInput!) {
        addReceipt(input: $input)
    }
`)

export const storeEncryptionKeyMutation = graphql(`
    mutation StoreEncryptionKey($key: String!) {
        storeEncryptionKey(key: $key)
    }
`)

export const updateCurrentSeasonCheckinSettingsMutation = graphql(`
  mutation UpdateCurrentSeasonCheckinSettings($input: UpdateCurrentSeasonCheckinSettingsInput!) {
    updateCurrentSeasonCheckinSettings(input: $input) {
      id
      checkinEmailActiveTime
      checkinEmailContent
      checkinProperties {
        id
        title
      }
      targetGroup {
        id
        properties {
          id
          title
        }
      }
    }
  }
`)

export const updateCurrentSeasonCrewInfoSettingsMutation = graphql(`
  mutation UpdateCurrentSeasonCrewInfoSettings($input: UpdateCurrentSeasonCrewInfoSettingsInput!) {
    updateCurrentSeasonCrewInfoSettings(input: $input) {
      id
      crewInfoActive
      crewInfoTextRaw
    }
  }
`)

export const updateCurrentSeasonScheduleEmailSettingsMutation = graphql(`
  mutation UpdateCurrentSeasonScheduleEmailSettings($input: UpdateCurrentSeasonScheduleEmailSettingsInput!) {
    updateCurrentSeasonScheduleEmailSettings(input: $input) {
      id
      scheduleEmailActiveTime
      scheduleEmailContent
      scheduleEmailChangeContent
      cancelationEmailContent
    }
  }
`)

export const updateCateringMealMutation = graphql(`
    mutation UpdateCateringMeal($input: UpdateCateringMealInput!) {
        updateCateringMeal(input: $input) {
            id
            begin
            end
            description
        }
    }
`)

export const createOrUpdateBingoGameItemMutation = graphql(`
  mutation CreateOrUpdateBingoGameItem($input: CreateOrUpdateBingoGameItemInput!) {
    createOrUpdateBingoGameItem(input: $input) {
      id
      title
      bingoGameItems {
        id
        title
        artist
        sort
      }
    }
  }
`)

export const deleteBingoGameItemMutation = graphql(`
  mutation DeleteBingoGameItem($input: DeleteBingoGameItemInput!) {
    deleteBingoGameItem(input: $input) {
      id
    }
  }
`)

export const createOrUpdateBingoGameMutation = graphql(`
  mutation CreateOrUpdateBingoGame($input: CreateOrUpdateBingoGameInput!) {
    createOrUpdateBingoGame(input: $input) {
      id
      title
      bingoGameItems {
        id
      }
    }
  }
`)

export const deleteBingoGameMutation = graphql(`
  mutation DeleteBingoGame($input: DeleteBingoGameInput!) {
    deleteBingoGame(input: $input) {
      id
      title
      bingoGameItems {
        id
      }
    }
  }
`)

export const createGroupMutation = graphql(`
  mutation CreateGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      id
      title
    }
  }
`)

export const updateGroupMutation = graphql(`
  mutation UpdateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      id
      title
      longTitle
      welcomeMessage
      footnote
      isPrivate
      isReadonly
      reuseMembership
      requiredNotificationPermissions
      newMembershipNotificationEmail
      updateMembershipNotificationEmail
      cancelMembershipNotificationEmail
    }
  }
`)

export const deleteGroupMutation = graphql(`
  mutation DeleteGroup($input: DeleteGroupInput!) {
    deleteGroup(input: $input) {
      id
      title
    }
  }
`)

export const createPropertyMutation = graphql(`
  mutation CreateProperty($input: CreatePropertyInput!) {
    createProperty(input: $input) {
      id
    }
  }
`)

export const updatePropertyMutation = graphql(`
  mutation UpdateProperty($input: UpdatePropertyInput!) {
    updateProperty(input: $input) {
      id
      title
      infotextHtml
      type
      sort
      shorten
      flatten
      isRequired
      isPrivate
      isReadonly
    }
  }
`)

export const deletePropertyMutation = graphql(`
  mutation DeleteProperty($input: DeletePropertyInput!) {
    deleteProperty(input: $input) {
      id
    }
  }
`)

export const createPropertyOptionMutation = graphql(`
  mutation CreatePropertyOption($input: CreatePropertyOptionInput!) {
    createPropertyOption(input: $input) {
      id
    }
  }
`)

export const updatePropertyOptionMutation = graphql(`
  mutation UpdatePropertyOption($input: UpdatePropertyOptionInput!) {
    updatePropertyOption(input: $input) {
      id
      title
      description
      limit
      sort
      disabledFlag
    }
  }
`)

export const deletePropertyOptionMutation = graphql(`
  mutation DeletePropertyOption($input: DeletePropertyOptionInput!) {
    deletePropertyOption(input: $input) {
      id
    }
  }
`)

export const createSeasonMutation = graphql(`
  mutation CreateSeason($input: CreateSeasonInput!) {
    createSeason(input: $input) {
      id
    }
  }
`)

export const updateSeasonMutation = graphql(`
  mutation UpdateSeason($input: UpdateSeasonInput!) {
    updateSeason(input: $input) {
      id
      title
      shortTitle
      isLatest
      constructionBegin
      constructionEnd
      begin
      end
      dismantlingBegin
      dismantlingEnd
      scheduleEditActive
      scheduleEditLeadersActive
      scheduleActiveTime
      targetGroup {
        id
      }
      targetGroupTextRaw
      targetGroupButtonText
      targetGroupSuccessTextRaw
      scheduleAgreementTextRaw
    }
  }
`)

export const setCurrentSeasonMutation = graphql(`
  mutation SetCurrentSeason($input: SetCurrentSeasonInput!) {
    setCurrentSeason(input: $input) {
      id
      isLatest
    }
  }
`)

export const createSectionMutation = graphql(`
  mutation CreateSection($input: CreateSectionInput!) {
    createSection(input: $input) {
      id
    }
  }
`)

export const updateSectionMutation = graphql(`
  mutation UpdateSection($input: UpdateSectionInput!) {
    updateSection(input: $input) {
      id
      title
    }
  }
`)

export const deleteSectionMutation = graphql(`
  mutation DeleteSection($input: DeleteSectionInput!) {
    deleteSection(input: $input)
  }
`)

export const createSectionRoleMutation = graphql(`
  mutation CreateSectionRole($input: CreateSectionRoleInput!) {
    createSectionRole(input: $input) {
      id
    }
  }
`)

export const deleteSectionRoleMutation = graphql(`
  mutation DeleteSectionRole($input: DeleteSectionRoleInput!) {
    deleteSectionRole(input: $input)
  }
`)

export const createOrganisationMutation = graphql(`
  mutation CreateOrganisation($input: CreateOrganisationInput!) {
    createOrganisation(input: $input) {
      id
      title
    }
  }
`)

export const updateOrganisationMutation = graphql(`
  mutation UpdateOrganisation($input: UpdateOrganisationInput!) {
    updateOrganisation(input: $input) {
      id
      title
    }
  }
`)

export const deleteOrganisationMutation = graphql(`
  mutation DeleteOrganisation($input: DeleteOrganisationInput!) {
    deleteOrganisation(input: $input)
  }
`)

export const createLineupItemMutation = graphql(`
  mutation CreateLineupItem($input: CreateLineupItemInput!) {
    createLineupItem(input: $input) {
      id
    }
  }
`)

export const updateLineupItemMutation = graphql(`
  mutation UpdateLineupItem($input: UpdateLineupItemInput!) {
    updateLineupItem(input: $input) {
      id
    }
  }
`)

export const deleteLineupItemMutation = graphql(`
  mutation DeleteLineupItem($input: DeleteLineupItemInput!) {
    deleteLineupItem(input: $input)
  }
`)

export const createLineupStageMutation = graphql(`
  mutation CreateLineupStage($input: CreateLineupStageInput!) {
    createLineupStage(input: $input) {
      id
    }
  }
`)

export const updateLineupStageMutation = graphql(`
  mutation UpdateLineupStage($input: UpdateLineupStageInput!) {
    updateLineupStage(input: $input) {
      id
    }
  }
`)

export const deleteLineupStageMutation = graphql(`
  mutation DeleteLineupStage($input: DeleteLineupStageInput!) {
    deleteLineupStage(input: $input)
  }
`)

export const joinFestivalMutation = graphql(`
  mutation JoinFestival($input: JoinFestivalInput!) {
    joinFestival(input: $input) {
      id
    }
  }
`)

export const selectFestivalMutation = graphql(`
  mutation SelectFestival($input: SelectFestivalInput!) {
    selectFestival(input: $input) {
      id
    }
  }
`)

export const leaveFestivalMutation = graphql(`
  mutation LeaveFestival($input: LeaveFestivalInput!) {
    leaveFestival(input: $input)
  }
`)

export const registerUserMutation = graphql(`
  mutation RegisterUser($input: RegisterUserInput!) {
    registerUser(input: $input)
  }
`)

export const requestPasswordResetMutation = graphql(`
  mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
    requestPasswordReset(input: $input)
  }
`)

export const resetPasswordMutation = graphql(`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`)

export const updateFestivalProfileMutation = graphql(`
  mutation UpdateFestivalProfile($input: UpdateFestivalProfileInput!) {
    updateFestivalProfile(input: $input) {
      id
      title
      teaser
      descriptionRaw
      location
      website
      logoBackground
      isPublic
      isJoinable
    }
  }
`)

export const createNewsMutation = graphql(`
  mutation CreateNews($input: CreateNewsInput!) {
    createNews(input: $input) {
      id
    }
  }
`)

export const updateNewsMutation = graphql(`
  mutation UpdateNews($input: UpdateNewsInput!) {
    updateNews(input: $input) {
      id
      title
      category
      publishDate
      teaser
      content
      isPublished
    }
  }
`)

export const deleteNewsMutation = graphql(`
  mutation DeleteNews($input: DeleteNewsInput!) {
    deleteNews(input: $input)
  }
`)

export const setGroupImageMutation = graphql(`
  mutation SetGroupImage($input: SetGroupImageInput!) {
    setGroupImage(input: $input) {
      id
      imageUrl
    }
  }
`)

export const setMembershipRolesMutation = graphql(`
  mutation SetMembershipRoles($input: SetMembershipRolesInput!) {
    setMembershipRoles(input: $input) {
      id
      isOwner
      roleIds
    }
  }
`)
